import { render, staticRenderFns } from "./PagoPaycometForm.vue?vue&type=template&id=227cdc2d"
import script from "./PagoPaycometForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PagoPaycometForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports